import React from "react";

export default function SimpleSection(props) {
  const { className, children, backgroundimage } = props;
  return (
    <section
      className={
        "c-simple-section " + (undefined !== className ? className : "")
      }
      style={
        undefined !== backgroundimage
          ? {
            background: "url(" + backgroundimage + ") no-repeat scroll 0 0 / 100% auto rgba(0, 0, 0, 0)",
            backgroundColor: "black"
          }
          : {backgroundColor: "black"}
      }
    >
      {children}
    </section>
  );
}
